import React from "react";
import ClientLayout from "./clientLayout/clientLayout";
import UnderMaintenance from "./underMaintenance/underMaintenance";

// Wrapper component to control rendering of maintenance mode or main client layout.
const ClientLayoutWrapper: React.FC<any> = (props) => {
  const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === "true";
  if (isMaintenance) {
    return <UnderMaintenance />;
  }
  return <ClientLayout {...props}>{props.children}</ClientLayout>;
};

export default ClientLayoutWrapper;
